import { Button } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';

const UndoRedoButtons = ({ undoChange, redoChange, past, future }) => {
  // If the props are not provided, return null to avoid rendering anything
  if (!undoChange || !redoChange || !past || !future) {
    return null;
  }

  return (
    <>
      <Button onClick={undoChange} disabled={past.length === 0}>
        <UndoIcon sx={{ color: "white" }} />
      </Button>
      <Button onClick={redoChange} disabled={future.length === 0}>
        <RedoIcon sx={{ color: "white" }} />
      </Button>
    </>
  );
};

export default UndoRedoButtons;
